import fkOrId from '@drivesally/sally-fw/lib/lib/fkOrId';

const attachService = ({item, services}) => {
  const service =
    [...services].find(
      (serviceToFind) => serviceToFind.id === fkOrId(item.service)
    ) || null;
  const attribute =
    !!service && !!item.attribute
      ? [...service.attributes].find(
          (attributeToFind) => attributeToFind.id === fkOrId(item.attribute)
        )
      : null;
  return {...item, service, attribute};
};

export default attachService;
